//DESERTLAND.Content.Resources
import { Utils } from '../cals.utils';
// import { DESERTLAND } from '../desertland.init';
import { App } from '../desertland.app';
import { ROUTES } from '../desertland.router';
// import { TemplateLoader } from '../desertland.templateLoader';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.layout';
// import 'kendo-ui-core/js/kendo.data';
// import 'kendo-ui-core/js/kendo.mobile.listview';

declare var log, info, warn, groupCollapsed, groupEnd;

export class ResourcesContent {
  public page = ROUTES.RESOURCES;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-resources';
  public subNavId = '#resources_sub_nav';

  public init(params = {}) {
    groupCollapsed("Resources.init");
    if ($(this.container).length) {
      log("ready for " + this.page);
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        log(this.page + " dom ready!");
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        }

      });
    }
    groupEnd("Resources.init");
  }

  public loadTpl(callback) {
    log(this.page + " > loadTpl");
    if ($(this.tplSel).length) {
      log("// we already have the tpl");
      this.renderTpl({ sel: this.tplSel });
    } else {
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl);
    }

  }

  public renderTpl = (resp) => {
    $(document).ready(() => {
      log(this.page + " > renderTpl", resp);
      if (resp && resp.sel && $(resp.sel).length) {
        //log($(resp.sel));
        let layout = new kendo.Layout($('#'+resp.tag).html(), { model: App.models.pageView.viewModel });
        $(this.container).empty();
        layout.render($(this.container));
  
        this.loadContent(this.formatThenRender);
  
        this.initEvents();
  
      } else {
        info("no sel?");
      }
    });
  }

  public loadContent(callback) {

    if (App.data.resources) {
      log("data exists, using");
      this.renderContent(App.data.resources);
    } else {
      App.service.load.resources(callback);
    }

    App.content.Learnmore.loadDataTheRenderSubnav(this.subNavId);
  }

  public formatThenRender = (data) => {
    groupCollapsed("Resources.Render");
    log("formatThenRender");
    // var me = DESERTLAND.Content.Resources; // in a callback
    let formatted = this.formatData(data);
    App.data.resources = formatted;
    this.renderContent(formatted);
    groupEnd("Resources.Render");
  }

  public formatData(data) {
    info("formatData", data);

    if (typeof data.sort === "function") {
      data.sort(function (a, b) {
        let nameA = a.title ? a.title.toUpperCase() : ""; // ignore upper and lowercase
        let nameB = b.title ? b.title.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    }

    // var cats = [];
    // var tip_cats = {};
    // var data_length = data.length;
    // for (var i = 0; i < data_length; i++) {
    //     if (!isEmpty(data[i].tip_group)) {
    //         var this_cat = data[i].tip_group;
    //         cats.pushIfNotExist(this_cat);
    //         if (!Utils.objectHasProperty(tip_cats, this_cat)) {
    //             tip_cats[this_cat] = {
    //                 cat_name : this_cat,
    //                 desc : "TODO", 
    //                 cat_num : "1-5",
    //                 items : []
    //             };  
    //         }
    //         tip_cats[this_cat].items.push(data[i]);
    //     }


    // }

    // var oRet = {
    //     // tip_cats : cats,
    //     // tips : tip_cats,
    //     // item_count : data_length
    //     data:data
    // };

    // log(oRet);
    return data;

  }

  public renderContent(data) {
    log("Resources > renderContent", data);
    if ($("#resources.page").length && $("#resource_list_container .container").length) {

      //var $headline = $("#tips.page .headline");//.hero-title  .hero-tagline                        

      // sticky subnav - the sticky lib is probably already called?
      //var $sticky = $("#sticky_subnav");
      //this.renderNav(data);

      // load content section
      //var $container = $("#tips_content_container .container").hide().empty();

      let dataSource = new kendo.data.DataSource({
        data
      });

      if ($("#resources-listview").length) {
        let tpl = '<div class="resource">'
          + '<h3><a href="#: url #" target="desertland_ext" rel="external">#:title#</a></h3>'
          + '<div>#= description #</div>'
          + '</div>';

        $("#resources-listview").kendoMobileListView({
          dataSource,
          template: tpl,
          dataBound(e) {
            log("resources-listview onDataBound", e);
            //$(DESERTLAND.Plants.subContainer + " > li").addClass("col-sm-4");
          }
        });
      }

      Utils.smoothScrollTo('top');

    } else {
      info("!#resources.page || !container");
    }
  }

  public initEvents() {

    if ($("#resources_print").length) {
      $("#resources_print").off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        log("resources_print click");
      });
    }

    if ($("#resources_online").length) {
      $("#resources_online").off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        log("resources_online click");
      });
    }

  }





}
